/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Account } from './Account';
import {
    AccountFromJSON,
    AccountFromJSONTyped,
    AccountToJSON,
} from './Account';
import type { Metadata } from './Metadata';
import {
    MetadataFromJSON,
    MetadataFromJSONTyped,
    MetadataToJSON,
} from './Metadata';

/**
 * 
 * @export
 * @interface ListAccounts200Response
 */
export interface ListAccounts200Response {
    /**
     * 
     * @type {Array<Account>}
     * @memberof ListAccounts200Response
     */
    data: Array<Account>;
    /**
     * 
     * @type {Metadata}
     * @memberof ListAccounts200Response
     */
    metadata: Metadata;
}

/**
 * Check if a given object implements the ListAccounts200Response interface.
 */
export function instanceOfListAccounts200Response(value: object): value is ListAccounts200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('metadata' in value) || value['metadata'] === undefined) return false;
    return true;
}

export function ListAccounts200ResponseFromJSON(json: any): ListAccounts200Response {
    return ListAccounts200ResponseFromJSONTyped(json, false);
}

export function ListAccounts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAccounts200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AccountFromJSON)),
        'metadata': MetadataFromJSON(json['metadata']),
    };
}

export function ListAccounts200ResponseToJSON(value?: ListAccounts200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(AccountToJSON)),
        'metadata': MetadataToJSON(value['metadata']),
    };
}

